import React, { useEffect } from "react";

const cognitoLoginUrl = process.env.REACT_APP_COGNITO_LOGIN_URL;
const Login = () => {
  const handleLogin = () => {
    if (cognitoLoginUrl) {
      window.location.href = cognitoLoginUrl;
    } else {
      console.error("Cognito login URL is not defined");
    }
  };
  useEffect(() => {
    handleLogin();
  }, []);
  return <div className="flex items-center justify-center min-h-screen bg-gray-100">Loading...</div>;
};

export default Login;
